'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import MarqueeBar from './components/MarqueeBar';
import ServicesPreview from './components/ServicesPreview';
import WorkSection from './components/WorkSection';
import BookingSection from './components/BookingSection';
import AboutSection from './components/AboutSection';

export default function HomePage() {
  return (
    <main
      className="min-h-screen overflow-x-hidden"
      style={{ background: '#0A0A0A' }}
    >
      <Header />
      <HeroSection />
      <MarqueeBar />
      <section id="services"><ServicesPreview /></section>
      <section id="work"><WorkSection /></section>
      <section id="contact"><BookingSection /></section>
      <section id="about"><AboutSection /></section>
      <Footer />
    </main>
  );
}